import React, {useState} from 'react';

import Close from "../assets/Close.svg"
import styled, {css} from 'styled-components/macro'
import {AnimatePresence, motion} from "framer-motion";
import Spinner from "./Spinner";
import CurrencyModal from "./CurrencyModal";

const Popup = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    z-index: 3;
`

const PopupInner = styled(motion.div)`
    text-align: left;
    vertical-align: middle;
    position: absolute;
    max-width: 700px;
    width: 671px;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    
    text-align: center;


`

const PopupHeader = styled.div`
    width: 100%;
    height: 24px;
    font-size: 19px;
    left: calc(50% - 623px/2);
    top: calc(50% - 24px/2 - 10px);
    line-height: 24px;
    font-weight: bold;
    display: flex;
    flex-direction: row;

    align-items: center;
    text-transform: capitalize;
`

const CloseButton = styled.a`
    width: 24px;
    margin-left: 400px;
    height: 24px;
    float: right;
    cursor: pointer;
`

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;    
`

const InputBoxContainer = styled.div`
    position: static;
    height: 68px;
    top: 8px;
    margin-bottom: 20px;
`

const InputBoxLabel = styled.div`
    display: flex;
    flex-direction:row;
    align-items: center;
    padding-left: 5px;
    
    white-space: nowrap;
    position: relative;
    height: 20px;
    width: ${props => props.FixedWidth || "10%"}};
    left: 30px;
    top: 10px;
    font-weight: bold;
    
    background: #FFFFFF;
`

const Required = styled.div`
    font-size: 11px;
    line-height: 16px;

    color: #DA1414;

    opacity: 0.8;
`

const InputBox = styled.input`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 0px 15px;
    
    position: static;
    width: 95%;
    height: 48px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    
    background: #FFFFFF;

    border: 1px solid #858C94;
    box-sizing: border-box;
    border-radius: 8px;
`

const PopupFooter = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;

`

const PopupButton = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    
    position: relative;
    width: 300px;
    height: 42px;
    margin: 15px;
    background: transparent;
    color: #FAC44E;
    border: 2px solid #FAC44E;

    border-radius: 30px;
    ${props => props.primary && css`
        background: #FAC44E;
        color: white;
    `}
    
    cursor: pointer;
`

const ProposalBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 30%;
    align-items: flex-start;
    min-width: 334px;
    height: 200px;
    margin-left: 0px;
    margin-top: 0px;
    margin-right: 30px;
    margin-bottom: 30px;
    align-items: center;

    background: #FFFFFF;
    /* shadow 1 */
    
    box-shadow: 4px 6px 20px rgba(176, 176, 176, 0.15);
    border-radius: 6px;
`

const ProposalBoxLabel = styled.div`
    width: 100%;
    height: 18px;
    margin-top: 45px;
    font-size: 26px;
    font-weight: bold;
    line-height: 100%;
    /* identical to box height, or 18px */

    text-align: center;
`

const ProposalBoxButton = styled(motion.button)`    
    justify-content: center;
    align-items: center;
    width: 60%;
    min-width: 238px;
    height: 50px;
    
    margin-top: 40px;

    /* yellow */
    background: linear-gradient(95.76deg, #FAC44E -0.92%, #F9AB12 96.25%);
    border-radius: 30px;
    border: none;
    
    font-weight: bold;
    font-size: 22px;
    
    /* or 25px */


    color: #FFFFFF;
    cursor: pointer;
    ${props => props.viewButton && css`
        border: 1px solid #F0C235;
        box-sizing: border-box;    
        border-radius: 41px;
        background: transparent;
        color: #FAC44E;
    `}
`

const SelectBox = styled.select`
    
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 14px 15px;
    
    position: static;
    width: 95%;
    height: 48px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    
    background: #FFFFFF;

    border: 1px solid #858C94;
    box-sizing: border-box;
    border-radius: 8px;
    
    option {
        color: black;
        background: white;
        display: flex;
        white-space: pre;
        min-height: 35px;
        
        padding: 14px 15px;
     }
     
    option[disabled]{
        display:none;
    }

`

const modalVariant = {
    initial: { opacity: 0 },
    isOpen: { opacity: 1 },
    exit: { opacity: 0 }
};

const containerVariant = {
    initial: { top: "-50%", transition: { type: "spring" } },
    isOpen: { top: "50%" },
    exit: { top: "-50%" }
};

const CreateProposalModal = (props) => {
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(false);

    // For member edit proposal
    const [memberAddress, setMemberAddress] = useState(props.label === "Remove Member" && props.boardMembers !== undefined ? props.boardMembers[0] : "");

    // For money transfer request
    const [transferTo, setTransferTo] = useState();
    const [transferAmount, setTransferAmount] = useState();

    // For voting threshold proposal
    const [votingThreshold, setVotingThreshold] = useState(0);

    // For sc address change proposal
    const [newAddress, setNewAddress] = useState("");

    const currencies = CurrencyModal();

    const [selectedCurrency, setCurrency] = useState(currencies[0].address.toString());

    const toggle = () => {
        setLoading(false);
        setModal(!modal);
    };

    return (
        <AnimatePresence>
            <ProposalBox>
                <ProposalBoxLabel>{props.label}</ProposalBoxLabel>
                <ProposalBoxButton
                    whileHover={{scale: 1.1}}
                    whileTap={{scale: 0.9}}
                    onClick={toggle}>Create Proposal</ProposalBoxButton>
            {
                modal && (
            <Popup
                initial={"initial"}
                animate={"isOpen"}
                exit={"exit"}
                variants={modalVariant}>
                <PopupInner variants={containerVariant}>
                    <PopupHeader>
                        {props.header}
                        <CloseButton onClick={toggle}><img src={Close}/></CloseButton>
                    </PopupHeader>
                    { loading ? (<Spinner/>): (
                    <ContentArea>
                        {
                            props.label !== "Add Member" ? ("") : (
                                <InputBoxContainer>
                                    <InputBoxLabel FixedWidth="20%">Member Address <Required>*</Required></InputBoxLabel>
                                    <InputBox onChange= {e => setMemberAddress(e.target.value)} required></InputBox>
                                </InputBoxContainer>
                            )
                        }
                        {
                            props.label !== "Remove Member" ? ("") : (
                                <InputBoxContainer>
                                    <InputBoxLabel FixedWidth="20%">Member Address <Required>*</Required></InputBoxLabel>
                                    <SelectBox onChange= {e => setMemberAddress(e.target.value)} required>
                                        {props.boardMembers.map((member, index) => {
                                            return (<option value={member.toString()} selected={memberAddress === member.toString()} key={index}>{member.toString()}</option>)
                                        })}
                                    </SelectBox>
                                </InputBoxContainer>
                            )
                        }
                        {
                            props.label !== "Change Voting Threshold" ? ("") : (
                                <InputBoxContainer>
                                    <InputBoxLabel FixedWidth="25%">New Voting Threshold<Required>*</Required></InputBoxLabel>
                                    <InputBox type="number" min="1" max={props.boardMembers.length} onChange= {e => setVotingThreshold(e.target.value)} required></InputBox>
                                </InputBoxContainer>
                            )
                        }
                        {
                            props.label !== "Create Request" ? ("") : (
                                <div>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth="27%">Address Transferring To <Required>*</Required></InputBoxLabel>
                                        <InputBox onChange= {e => setTransferTo(e.target.value)} required></InputBox>
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth="11%">Currency<Required>*</Required></InputBoxLabel>
                                        <SelectBox onChange= {e => {
                                            setCurrency(e.target.value);
                                        }} required>
                                            {currencies.map((currency, index) => {
                                                return (<option value={currency.address.toString()} key={index}>{currency.name.toString()}</option>)
                                            })}
                                        </SelectBox>
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth="19%">Transfer Amount<Required>*</Required></InputBoxLabel>
                                        <InputBox type="number" min="0" onChange= {e => setTransferAmount(e.target.value)} required></InputBox>
                                    </InputBoxContainer>
                                </div>
                            )
                        }
                        {
                            props.label !== "Change SPV Wallet" &&
                            props.label !== "Change Loan Originator" &&
                            props.label !== "Change Land Registration" ? ("") : (
                                <InputBoxContainer>
                                    <InputBoxLabel FixedWidth="33%">New Smart Contract Address <Required>*</Required></InputBoxLabel>
                                    <InputBox onChange= {e => setNewAddress(e.target.value)} required></InputBox>
                                    {props.currentAddress !== undefined ? (
                                        <InputBoxLabel>Current Address: {props.currentAddress}</InputBoxLabel>
                                    ) : ("")}
                                </InputBoxContainer>
                            )
                        }
                    </ContentArea>
                    )}
                    <PopupFooter>
                        <PopupButton onClick={toggle}>Cancel</PopupButton>
                        <PopupButton onClick={() => {
                            setLoading(true);
                            if(props.label === "Add Member") {
                                    props.action(memberAddress)
                                        .catch(()=>{
                                            setLoading(false);
                                    })
                                }
                            if(props.label === "Remove Member") {
                                let toRemove = memberAddress;
                                if(memberAddress === undefined) {
                                    toRemove = props.boardMembers[0];
                                }
                                props.action(toRemove)
                                    .catch(()=>{
                                        setLoading(false);
                                    })
                            }
                            if (props.label === "Change Voting Threshold") {
                                    props.action(votingThreshold)
                                        .catch(()=>{
                                            setLoading(false);
                                    })
                                }
                            if(props.label === "Create Request") {
                                props.action(selectedCurrency, transferTo, transferAmount)
                                    .catch(()=>{
                                        setLoading(false);
                                    })
                            }
                            if(props.label === "Change SPV Wallet" ||
                                props.label === "Change Loan Originator" ||
                                props.label === "Change Land Registration") {
                                props.action(newAddress)
                                    .catch(()=>{
                                        setLoading(false);
                                    })
                            }
                        }
                        }primary>{props.label}</PopupButton>
                    </PopupFooter>
                </PopupInner>
            </Popup>
                )
            }
            </ProposalBox>
        </AnimatePresence>
    );
};

export default CreateProposalModal;
